export const MAX_RASTER_IMAGE_BYTES = 1024 * 1024;

export function isBoundedRasterDataUrl(value) {
  if (typeof value !== 'string' || value.length > Math.ceil(MAX_RASTER_IMAGE_BYTES / 3) * 4 + 64) return false;
  const match = value.match(/^data:image\/(png|jpeg|gif|webp);base64,([A-Za-z0-9+/]+={0,2})$/);
  if (!match || match[2].length % 4 !== 0) return false;
  return match[2].length / 4 * 3 - (match[2].match(/=+$/)?.[0].length || 0) <= MAX_RASTER_IMAGE_BYTES;
}
